import React from 'react';

import BaseOnboardingFlow from '@components/Onboarding/BaseOnboardingFlow';
import { Route } from 'react-router-dom';

import OnboardingPublisherCompanyType from '@components/Publisher/Onboarding/OnboardingPublisherCompanyType';
import OnboardingPublisherLinkedIn from '@components/Publisher/Onboarding/OnboardingPublisherLinkedIn';
import OnboardingPublisherReferralSource from '@components/Publisher/Onboarding/OnboardingPublisherReferralSource';

import { RealmType } from 'respona_api/generated/common_pb';
import { OrganizationOnboardingPublisherDetails } from 'respona_api/generated/user-organization_pb';
import { OrganizationPublisherOnboardingType } from '@ts/userOrganization.types';

function PublisherOnboardingPage(): JSX.Element {
  const stepPaths = [
    '/onboarding/type-of-company',
    '/onboarding/linkedin',
    '/onboarding/referral-source',
  ];

  return (
    <BaseOnboardingFlow<OrganizationPublisherOnboardingType>
      realm={RealmType.RESPONA_PUBLISHER}
      cacheKey="publisher"
      selectRealmDetails={(d) => d?.publisher}
      buildRealmRequest={(merged) => {
        const realmReq = new OrganizationOnboardingPublisherDetails();
        if ((merged as any).brandManagementType !== undefined) {
          realmReq.setBrandManagementType((merged as any).brandManagementType);
        }
        if ((merged as any).linkedIn !== undefined) {
          realmReq.setLinkedIn((merged as any).linkedIn);
        }
        if ((merged as any).referralSource !== undefined) {
          realmReq.setReferralSource((merged as any).referralSource);
        }
        return realmReq;
      }}
      attachRealmRequest={(root, realmReq) => root.setPublisher(realmReq)}
      stepPaths={stepPaths}
      renderRoutes={({ details, onSave, onBack, onContinue }) => (
        <>
          <Route path="/onboarding/type-of-company">
            <OnboardingPublisherCompanyType
              details={details}
              onSave={onSave}
              onBack={onBack}
              onContinue={onContinue}
            />
          </Route>
          <Route path="/onboarding/linkedin">
            <OnboardingPublisherLinkedIn
              details={details}
              onSave={onSave}
              onBack={onBack}
              onContinue={onContinue}
            />
          </Route>
          <Route path="/onboarding/referral-source">
            <OnboardingPublisherReferralSource
              details={details}
              onSave={onSave}
              onBack={onBack}
              onContinue={onContinue}
            />
          </Route>
        </>
      )}
    />
  );
}

export default PublisherOnboardingPage;
